import { useTranslation } from "react-i18next";
import i18n from "locales/i18n";

import PageWrapper from "components/page/PageWrapper";
import Section from "./Section";

import bg from 'assets/images/banner/banner02.jpg';
import repowering from 'assets/images/solutions/repowering/repowering.jpg'
import pcSrc1Ko from 'assets/images/solutions/repowering/ko/pc-1.png';
import pcSrc2Ko from 'assets/images/solutions/repowering/ko/pc-2.png';
import mobileSrc1Ko from 'assets/images/solutions/repowering/ko/mobile-1.jpg';
import mobileSrc2Ko from 'assets/images/solutions/repowering/ko/mobile-2.jpg';
import pcSrc1En from 'assets/images/solutions/repowering/en/pc-1.png';
import pcSrc2En from 'assets/images/solutions/repowering/en/pc-2.png';
import mobileSrc1En from 'assets/images/solutions/repowering/en/mobile-1.jpg';
import mobileSrc2En from 'assets/images/solutions/repowering/en/mobile-2.jpg';

export default function Repowering(){
  const {t} = useTranslation();
  const locale = i18n.language?? 'ko';
  const menuName= t('menu.sub-repowering');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/repowering', name:menuName}];
  const title = t('repowering.banner.title')
  const comment = t('repowering.banner.comment')

  const rowData=[];
  for(let i = 1; i < 4; i++){
    rowData.push({
      title:t(`repowering.body.table.title-${i}`),
      data:[
        t(`repowering.body.table.${i}-1`),
        t(`repowering.body.table.${i}-2`),
        t(`repowering.body.table.${i}-3`)
      ]
    });
  }

  const imgs = {
    src1:{
      pc:{ko:pcSrc1Ko, en:pcSrc1En},
      mobile:{ko:mobileSrc1Ko, en:mobileSrc1En}
    },
    src2:{
      pc:{ko:pcSrc2Ko, en:pcSrc2En},
      mobile:{ko:mobileSrc2Ko, en:mobileSrc2En}
    }
  }

  const section1={
    title:t('repowering.body.section-1.title'),
    comment:t('repowering.body.section-1.comment'),
  }

  const section2={
    title:t('repowering.body.section-2.title'),
    titles:[
      t('repowering.body.section-2.sub-title-1'),
      t('repowering.body.section-2.sub-title-2'),
      t('repowering.body.section-2.sub-title-3'),
    ],
    comments:[
      t('repowering.body.section-2.comment-1'),
      t('repowering.body.section-2.comment-2'),
      t('repowering.body.section-2.comment-3')
    ]
  }

  const section3={
    title:t('repowering.body.section-3.title'),
    titles:[
      t('repowering.body.section-3.sub-title-1')],
    comments:[
      t('repowering.body.section-3.comment-1')
    ]
  }

  const tdStyle = (index, col)=>{
    return `text-center w-[200px] py-5 text-xs lg:text-base ` +
      `${index%2!==0? 'bg-white':'bg-gray-100'} `+
      `${col===1||col===2? 'border-l border-r border-sky-600':''}`;
  };

  const rows = rowData.map((r, index)=>{
    return (
      <tr key={r.title} 
        className={`${index===0? 'border border-t-2 border-t-sky-600':""}` + 
                  `${index===rowData.length-1? 'border border-b-2 border-b-sky-600':""}`}>
        <th className={`w-[200px] font-semibold ${index%2===0? 'bg-sky-600 text-white':'bg-gray-100 text-black'}`+
                        ` text-sm lg:text-base` }>{r.title}</th>
        {[1, 2, 3].map((col)=><td key={col} className={tdStyle(index, col)}>{r.data[col-1]}</td>
        )}
      </tr>
    );
  });

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
    <div className="flex flex-row justify-center px-mobile">
      <div className="flex flex-col lg:w-[1200px]">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between"> {/* 상단 부분 */}
          <div className="mb-10 lg:mr-20 lg:mb-0">
            <p className="mb-8 text-2xl font-light lg:text-3xl lg:mb-12">{t('repowering.body.service')}</p>
            <p className="text-xs text-gray-500 lg:text-base" 
              dangerouslySetInnerHTML={{__html:t('repowering.body.desc')}}></p>
          </div>
        <div>
          <img src={repowering} width={520} className="lg:min-w-[520px]" alt='repowering'/>
        </div>
      </div>
      <Section title={section1.title} comment={section1.comment}/>
      <div className="flex justify-center mb-14">
        <table className="">
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
      <picture>
        <source media="(min-width: 1024px)" srcSet={imgs.src1.pc[locale]}/>
        <img src={imgs.src1.mobile[locale]} alt=''/>
      </picture>
      <Section title={section2.title} titles={section2.titles} comments={section2.comments}/>
      <Section title={section3.title} titles={section3.titles} comments={section3.comments}/>
      <picture className="mb-10 lg:mb-20">
        <source media="(min-width: 1024px)" srcSet={imgs.src2.pc[locale]}/>
        <img src={imgs.src2.mobile[locale]} alt=''/>
      </picture>
    </div>
  </div>
    </PageWrapper>
  );
}